<template>
    <div class="d-flex flex-column" style="gap: var(--space-5)">
        <div
            v-if="
                (audit.score_override >= 0 || audit.form_max_score) &&
                audit.completed_at
            "
            class="w-100 d-flex justify-content-center align-items-center p-2 gap-3"
            style="
                background-color: var(--primary-25);
                border-radius: var(--radius-default);
            "
        >
            <h3 style="color: var(--neutral-800)">Overall</h3>
            <ProgressCircle
                :percentage="
                    audit.score_override ??
                    Math.round((audit.form_score / audit.form_max_score) * 100)
                "
            />
        </div>
        <div class="d-flex flex-column">
            <div v-if="audit.date" class="detail-list-item">
                <span class="label">Date</span>
                <span class="value"
                    ><strong>{{ formatMediumDate(audit.date) }}</strong></span
                >
            </div>
            <div v-if="formattedAuditType" class="detail-list-item">
                <span class="label">Type</span>
                <span class="value"
                    ><strong>{{ formattedAuditType }}</strong></span
                >
            </div>
            <div
                v-if="audit.site_name && !$siteStore.isSingleSiteUserView"
                class="detail-list-item"
            >
                <span class="label">Site</span>
                <span class="value"
                    ><strong>{{ audit.site_name }}</strong></span
                >
            </div>
            <div v-if="audit.auditor" class="detail-list-item">
                <span class="label">Auditor</span>
                <span class="value"
                    ><strong>{{ audit.auditor }}</strong></span
                >
            </div>
            <div v-if="audit.area_name" class="detail-list-item">
                <span class="label">Area</span>
                <span class="value"
                    ><strong>{{ audit.area_name }}</strong></span
                >
            </div>
            <div v-if="audit.details" class="detail-list-item">
                <span class="label">Notes</span>
                <strong class="value">{{ audit.details }}</strong>
            </div>
            <div
                v-if="audit.files && audit.files.length > 0"
                class="image-card"
            >
                <AdvancedUploadField
                    accept="image"
                    :multiple="false"
                    :max-image-height="500"
                    :max-image-width="500"
                    v-model="files"
                    :disabled="true"
                    :hideUploadField="true"
                />
            </div>
        </div>
        <div class="d-flex justify-content-end" style="gap: var(--space-3)">
            <button
                v-if="audit.form_json"
                class="btn btn-primary"
                @click="this.$emit('view-audit')"
            >
                View Audit
                <i class="fi fi-eye"></i>
            </button>
            <button
                v-else-if="audit.template_id"
                class="btn btn-primary"
                @click="this.$emit('perform-audit')"
            >
                Perform Audit
                <i class="fi fi-add"></i>
            </button>
            <button
                v-if="
                    $userStore.hasPerm('audits:write') &&
                    (!audit.app_admin_only || isAdminRoute)
                "
                class="icon-btn icon-btn-light"
                @click="handleEditAudit"
            >
                <i class="fi fi-edit"></i>
            </button>
            <CopyButton
                v-if="isAdminRoute"
                :copy-text="copyText"
                :disabled="!copyText"
                :alert-text="`Link copied to clipboard`"
                button-class="icon-btn icon-btn-light"
                title="Copy audit link"
            />
            <button
                v-if="
                    $userStore.hasPerm('audits:write') &&
                    (!audit.app_admin_only || isAdminRoute)
                "
                class="icon-btn icon-btn-white"
                @click="handleDeleteAudit"
            >
                <i class="fi fi-trash"></i>
            </button>
        </div>
    </div>
</template>

<script>
import AdvancedUploadField from '../fields/AdvancedUploadField.vue';
import ProgressCircle from '../ProgressCircle.vue';
import CopyButton from '@/components/fields/CopyButton.vue';

import { formatMediumDate } from '@/utils/dateUtils';

export default {
    name: 'AuditSummaryView',
    components: {
        ProgressCircle,
        AdvancedUploadField,
        CopyButton,
    },
    props: {
        audit: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            files: [],
        };
    },
    emits: ['open-modal'],
    computed: {
        isAdminRoute() {
            return this.$route.matched.some((r) => r.name === 'Admin');
        },
        copyText() {
            return this.audit?.hash
                ? `${window.location.origin}/audits/${this.audit.hash}`
                : '';
        },
        formattedAuditType() {
            if (!this.audit?.audit_type) return null;
            const type = this.audit.audit_type;
            return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
        },
    },
    methods: {
        formatMediumDate,
        handleEditAudit() {
            if (!this.$userStore.companyHasPerm('audits:write')) {
                this.$userStore.togglePremiumModal(true);
                return;
            }
            this.$emit('edit-audit');
        },
        handleDeleteAudit() {
            if (!this.$userStore.companyHasPerm('audits:write')) {
                this.$userStore.togglePremiumModal(true);
                return;
            }
            this.$emit('open-modal');
        },
    },
    mounted() {
        this.files = this.audit?.files ?? [];
    },
};
</script>

<style scoped>
.detail-list-item {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.625rem 0;
    border-bottom: 1px solid var(--neutral-600, #e6e6e6);
}

.image-card {
    padding: var(--space-3);
    gap: 0.75rem;
    background-color: var(--neutral-400);
    border-radius: var(--space-3);
}

.footer {
    width: 100%;
    height: 50px;
}
</style>
